<template>
<div class="loginPopMarsk">
  <div class="loginPop">
    <img @click="closePop()" src="../../assets/images/home/close.png" alt="" class="close">
    <div class="popTitle">{{$t('lang.login.Continue')}}</div>
    <div class="loginPage">
      <div class="loginContainer">
        <div class="login" v-if="this.$store.state.loginStatus === 'login'">
          <div class="title">{{ $t('lang.setting.mobile') }}</div>
          <div class="input">
            <div class="selectInput" @click="showPopup = true">
              <span>+{{ countryCode }}</span>
              <img style="margin-left: 2vw;width: 3.611vw" :src="dropDown" alt=""/>
            </div>
            <input type="number" class="telInput" v-model="tel" @input="limitInputLength('tel',20)">
            <div class="err" v-if="showErr">
              {{ $t('lang.login.invalid') }}
            </div>
          </div>
          <div class="title" v-if="picSwitch&&countdown <= 0">{{ $t('lang.login.captcha') }}</div>
          <div class="input" v-if="picSwitch&&countdown <= 0">
            <input type="text" class="snsInput" v-model="pictureCode" maxlength="4">
            <div class="picBtn" @click="initPicture">
              <img :src="codePicture" alt=""
                   style="padding-top: 7px;background-color: #BDB0B0;height: 100%;"/>
            </div>
          </div>
          <div class="title">{{ $t('lang.login.otp') }}</div>
          <div class="input">
            <input type="number" class="snsInput" v-model="sns" @input="limitInputLength('sns',8)">
            <div :class="countdown === 0&&tel&&(picSwitch&&pictureCode||!picSwitch) ? 'resend' : 'wait'"
                 @click="getSns">
              {{ $t('lang.login.sendOtp') }}{{ countdown > 0 ? `(${countdown}s)` : '' }}
            </div>
          </div>
        </div>
        <div class="login" v-if="this.$store.state.loginStatus === 'register'">
          <div class="caption">
            {{ $t('lang.login.username') }}
          </div>
          <div class="input">
            <label>
              <input type="text" v-model="userName">
            </label>
            <div class="err" v-if="showErr">
              {{ $t('lang.login.invalid') }}
            </div>
          </div>
          <div class="caption">
            {{ $t('lang.login.depositCur') }}
          </div>
          <div class="input">
            <div class="selectInput" style="width: 100%" @click="showPopup = true">
              {{ currency }}&nbsp;{{ fetchCurrency[currency] }}
            </div>
          </div>
          <div class="caption" style="margin-top: 10px" v-if="!cid || !cid.startsWith('app')">
            {{ $t('lang.login.couponCode') }}
          </div>
          <div class="input">
            <label v-if="!cid">
              <input type="text" v-model="couponCode">
            </label>
            <label v-else-if="cid && !cid.startsWith('app')">
              <input type="text" v-model="couponCode" readonly>
            </label>
          </div>
        </div>
        <div class="btn">
          <div
            :class="hasSendOtp&&((codePicture&&tel&&sns&&pictureCode)||(!codePicture&&tel&&sns)) ? 'submit' : 'disabled'"
            @click="fetchSubmit">
            {{ $t('lang.common.submit') }}
          </div>
        </div>
        <div class="GoogleLoginBox">
          <GoogleLogin :LoginMethod="LoginByGoogle"/>
        </div>
      </div>
      <Popup
        v-model='showPopup'
        position='bottom'>
        <Picker
          :slots="this.$store.state.loginStatus === 'login' ? countryCodeSlots : currencySlots"
          :showToolbar="true"
          @change="onValueChange">
          <span @click="showPopup = false">Done</span>
        </Picker>
      </Popup>
      <div class="inactive" v-if="showInactive">
        <div class="close"><img class="close" :src="close" alt="fork" @click="showInactive = false"/></div>
        <div class="ban">
          <img :src="ban" alt="ban"/>
        </div>
        <div class="tips">
          {{ $t('lang.login.abnormalPrompt1') }}<br><br>{{ $t('lang.login.abnormalPrompt5') }}
          <a href="mailto:support@pgebet.com">support@pgebet.com</a> {{ $t('lang.login.abnormalPrompt2') }}
          <a href="javascript:void(0)" @click="handleOpenChat">{{ $t('lang.login.abnormalPrompt3') }}</a>
          {{ $t('lang.login.abnormalPrompt4') }}
        </div>
        <div class="liveButton" @click="handleOpenChat">{{ $t('lang.support.customerService') }}</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import back from '@/assets/images/common/back.svg'
import permit from '@/assets/images/common/sharePermit.png'
import liveChat from '@/assets/images/common/liveChat.png'
import dropDown from '@/assets/images/login/dropDown.svg'
import ban from '@/assets/images/login/ban.png'
import close from '@/assets/images/login/close.png'
import cellPhone1 from '@/assets/images/login/cell_phone_1.svg'
import loginBanner from '@/assets/images/login/loginBanner.webp'
import loginLogo from '@/assets/images/login/loginLogo.png'
import cellPhone2 from '@/assets/images/login/cell_phone_2.svg'
import loginProgress from '@/assets/images/login/IN-login-progrss.png'
import {Popup, Picker, Toast} from 'mint-ui'
import request from '@/service'
import {LogUtils, afListener} from '@/utils'
import store from '../../store/store'
import {fetchCurrency, InternationCurrency} from '@/constant'
import {mapMutations} from 'vuex'
import GoogleLogin from '@/components/GoogleAuth/index'

export default {
  name: 'Login',
  data () {
    return {
      ban,
      close,
      back,
      permit,
      loginLogo,
      loginBanner,
      liveChat,
      dropDown,
      cellPhone1,
      cellPhone2,
      loginProgress,
      slogan: '',
      countryCode: '',
      tel: '',
      picSwitch: false, // 图形验证开关
      pictureCode: '', // 验证码
      codePicture: '', // 图形
      inviteCode: '',
      sns: '',
      userName: '',
      currency: 'INR',
      showPopup: false,
      countryCodeSlots: [
        {
          flex: 1,
          values: [
            'India +91',
            'Vietnam +84',
            'Australia +61',
            'New Zealand +64',
            'UAE +971'
          ],
          textAlign: 'center'
        }
      ],
      currencySlots: [
        {
          flex: 1,
          values: [
            'INR ₹'
            /* 'USD $',
            'EUR €',
            'CNY ￥' */
          ],
          textAlign: 'center'
        }
      ],
      fetchCurrency,
      InternationCurrency,
      loginStatus: this.$store.state.loginStatus,
      showErr: false,
      showInactive: false,
      email: '',
      password: '',
      emailReg: RegExp(/^(.+)@(.+)$/),
      passwordReg: RegExp(/^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{8,18}$/),
      couponCode: localStorage.getItem('cid'),
      cid: localStorage.getItem('cid'),
      fromRoute: '',
      countdown: 0,
      visitorCode: '',
      hasSendOtp: false
    }
  },
  components: {
    GoogleLogin,
    Popup,
    Picker
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fromRoute = from.name
      vm.setLoginStatus('login')
    })
  },
  async mounted () {
    this.visitorCode = await LogUtils.getVisitorCode()
    this.initPicture()
    this.slot = this.countryCodeSlot
    this.currencySlots[0].values = InternationCurrency.getCurrency(this.$store.state.internation)
    this.shareType = localStorage.getItem('shareType')
    this.inviteCode = localStorage.getItem('shareCode') ? localStorage.getItem('shareCode') : null
  },
  methods: {
    ...mapMutations({
      setInternation: 'setInternation',
      setInternationName: 'setInternationName',
      setLocale: 'setLocale',
      setLoginStatus: 'setLoginStatus'
    }),
    LoginByGoogle (googleId, mail) {
      let cid = localStorage.getItem('cid')
      let data = {
        email: mail,
        GoogleId: googleId,
        countryCode: this.countryCode,
        currencyName: this.countryCode === '91' ? 'INR' : 'BRL',
        campaignId: cid,
        shareCode: this.inviteCode,
        visitorCode: this.visitorCode,
        internation: this.$store.state.internation
      }
      let VIRdataStr = localStorage.getItem('shareVIRData')
      let VIRdata = null
      if (VIRdataStr) {
        VIRdata = JSON.parse(VIRdataStr)
      }
      if (VIRdata) {
        data.campaignId = VIRdata.cid
        data.VirShare = 'VIR'
      }
      const url = '/innovation/account/register/from/googleid'
      request('post', url, data).then(res => {
        if (res.Code === 0) {
          localStorage.setItem('userInfo', JSON.stringify({...res}))
          if (!localStorage.getItem('cid') && !res.CampaignId && cid) {
            localStorage.setItem('cid', cid)
          }
          if (res.CampaignId) {
            localStorage.setItem('cid', res.CampaignId)
          }
          setTimeout(() => {
            this.$router.push({path: '/Home', query: {}})
          }, 500)
        } else if (res.Code === 3) {
          Toast(this.$t('lang.loginError.error03'))
          this.setLoginStatus('login')
        } else if (res.Code === 2) {
          Toast(this.$t('lang.loginError.error02'))
          this.setLoginStatus('login')
        } else if (res.Code === 10100) {
          Toast(this.$t('lang.loginError.error10100'))
          this.setLoginStatus('login')
        } else if (res.Code === 60002) {
          Toast(this.$t('lang.loginError.error60002'))
          this.vCode = ''
          this.sessionCode = ''
          this.getValidateCodeImg()
          this.setLoginStatus('login')
        } else if (res.Code === 60001) {
          Toast(this.$t('lang.loginError.error60001'))
          this.vCode = ''
          this.sessionCode = ''
          this.getValidateCodeImg()
          this.setLoginStatus('login')
        } else if (res.Code === 10001) {
          Toast(this.$t('lang.loginError.error10001'))
          this.setLoginStatus('login')
        } else if (res.Code === 10042) {
          Toast(this.$t('lang.loginError.error10042'))
          this.setLoginStatus('login')
        } else if (res.Code === 10043) {
          Toast(this.$t('lang.loginError.error10043'))
          this.setLoginStatus('login')
        } else if (res.Code === 10051) {
          Toast(this.$t('lang.loginError.error10051'))
          this.setLoginStatus('login')
        } else if (res.Code === 10044) {
          Toast(this.$t('lang.loginError.error10044'))
          this.setLoginStatus('login')
        } else if (res.Code === 10053) {
          Toast(this.$t('lang.loginError.error10053'))
          this.setLoginStatus('login')
        } else if (res.Code === 10059) {
          Toast(this.$t('lang.loginError.error10059'))
          this.setLoginStatus('login')
        } else if (res.Code === 10052) {
          Toast('GoogleId already exists!')
          this.setLoginStatus('login')
        } else if (res.Code === 10054) {
          Toast('FacebookId already exists!')
          this.setLoginStatus('login')
        } else if (res.Code === 10060) {
          Toast(this.$t('lang.loginError.error10060'))
          this.setLoginStatus('login')
        } else if (res.Code === 10111) {
          Toast(this.$t('lang.login.toast10111'))
          this.setLoginStatus('login')
        } else if (res.Code === 10122) {
          Toast(this.$t('lang.login.toast10122'))
          this.setLoginStatus('login')
        }
      }).catch(err => {
        Toast('Fail')
        console.log(err)
      })
    },
    limitInputLength (mode, maxLength) {
      if (mode === 'tel' && this.tel.length > maxLength) {
        this.tel = this.tel.slice(0, maxLength) // 如果超过最大长度，截断输入
      } else if (mode === 'sns' && this.sns.length > maxLength) {
        this.sns = this.sns.slice(0, maxLength) // 如果超过最大长度，截断输入
      }
    },
    closePop () {
      this.$store.commit('setLoginPopShow', false)
    },
    handleOpenChat () {
      if (this.userInfo && this.userInfo.UserShowId) {
        window.LiveChatWidget.call('set_customer_name', this.userInfo.UserShowId)
      } else {
        window.LiveChatWidget.call('set_customer_name', ' ')
      }
      window.LiveChatWidget.call('maximize')
    },
    initPicture () {
      const url = '/innovation/account/get/rvc'
      const data = {SessionCode: this.visitorCode}
      request('post', url, data).then(res => {
        if (res) {
          this.picSwitch = res.Switch
          this.codePicture = res.Image
        }
      }).catch(err => {
        console.log(err)
      })
    },
    onValueChange (picker, value) {
      if (this.$store.state.loginStatus === 'login') {
        this.countryCode = value[0].split('+')[1]
      } else {
        this.currency = value[0].split(' ')[0]
      }
    },
    isSameDay (timestamp1, timestamp2) {
      // 将时间戳转换为 Date 对象
      const date1 = new Date(timestamp1)
      const date2 = new Date(timestamp2)

      // 比较年、月、日是否相同
      const isSameYear = date1.getFullYear() === date2.getFullYear()
      const isSameMonth = date1.getMonth() === date2.getMonth()
      const isSameDay = date1.getDate() === date2.getDate()

      // 如果年、月、日都相同，则表示在同一天
      return isSameYear && isSameMonth && isSameDay
    },
    countdownTimer () {
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1
          this.countdownTimer()
        }, 1000)
      } else if (this.countdown === 0) {
        this.initPicture()
        this.pictureCode = ''
      }
    },
    fetchSubmit () {
      store.commit('setFromLoggedIn', true) // 2022-10-08 HHY 设置来自登录页面
      switch (this.$store.state.loginStatus) {
        case 'login':
          if (!this.tel) {
            Toast(this.$t('lang.login.invalid'))
            return
          }
          if (!this.sns) {
            // this.showErr = true
            Toast(this.$t('lang.login.incorrectCode'))
            return
          }
          if (!this.hasSendOtp) {
            Toast(this.$t('lang.login.incorrectCode'))
            return
          }
          this.login()
          break
        case 'register':
          this.register()
          break
      }
    },
    getSns () {
      if (this.countdown > 0) {
        Toast(this.$t('lang.login.tooOften').replace('{seconds}', this.countdown))
        return
      }
      if (!this.tel) {
        Toast(this.$t('lang.login.invalid'))
        return
      }
      if (this.picSwitch && !this.pictureCode) {
        Toast('Invalid captcha!')
        return
      }
      this.hasSendOtp = true
      const url = '/innovation/account/sendsns'
      const data = {
        SnsCode: this.pictureCode,
        mobile: this.tel,
        countryCode: this.countryCode,
        visitorCode: this.visitorCode,
        campaignId: localStorage.getItem('cid'),
        inviteCode: this.inviteCode // 2022-12-20 HHY
      }
      request('post', url, data).then(res => {
        switch (res.Code) {
          case 10111:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            this.pictureCode = ''
            this.initPicture()
            if (res.Message) {
              Toast(this.$t('lang.login.toast10111') + res.Message)
            } else {
              Toast(this.$t('lang.login.toast10111'))
            }
            break
          case 10122:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            this.pictureCode = ''
            this.initPicture()
            if (res.Message) {
              Toast(this.$t('lang.login.toast10122') + res.Message)
            } else {
              Toast(this.$t('lang.login.toast10122'))
            }
            break
          case 10002:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            this.pictureCode = ''
            this.initPicture()
            if (res.Message) {
              Toast(this.$t('lang.login.toast10002') + res.Message)
            } else {
              Toast(this.$t('lang.login.toast10002'))
            }
            break
          case 10003:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            this.showInactive = true
            this.pictureCode = ''
            this.initPicture()
            break
          case 90005:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            Toast('Invite Code input is invalid.')
            this.pictureCode = ''
            this.initPicture()
            break
          case 90006:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            Toast('The OTP code has been exhausted, please register again tomorrow.')
            this.pictureCode = ''
            this.initPicture()
            break
          case 90007:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            Toast('Message doesn’t send successfully, please try once again.')
            this.pictureCode = ''
            this.initPicture()
            break
          case 60002:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            Toast('Invalid captcha!')
            this.pictureCode = ''
            this.initPicture()
            break
          default:
            this.countdown = 60
            this.countdownTimer()
            this.sns = res.CodeForTestOnly
        }
      }).catch(() => {
        LogUtils.saveUserEventParams('sendSnsError', '', -1, '{visitorCode:' + this.visitorCode + '}')
        if (this.picSwitch) {
          this.pictureCode = ''
          this.initPicture()
        }
        Toast('Fail')
      })
    },
    /****
     * 2021-08-04 C007 注册成功重设7天Gift和24小时充值送弹框状态
     */
    login () {
      const url = '/innovation/account/login'
      const data = {
        mobile: this.tel,
        countryCode: this.countryCode,
        snsCode: this.sns,
        visitorCode: this.visitorCode,
        campaignId: localStorage.getItem('cid')
      }
      request('post', url, data).then(res => {
        if (res.Code === 1) {
          localStorage.setItem('userInfo', JSON.stringify({
            ...data,
            ...res
          }))
          try { // START 2022-02-09 CHP 设置CampaignId
            localStorage.setItem('cid', res.CampaignId)
            // END 2022-02-09 CHP 设置CampaignId
          } catch (e) {
          }
          afListener('Login')
          this.fetchNext()
        } else if (res.Code === 3) {
          Toast(this.$t('lang.login.codeExpired'))
          // this.loginStatus = 'login'
          this.setLoginStatus('login')
        } else if (res.Code === 4) {
          Toast(this.$t('lang.login.invalidCode'))
          // this.loginStatus = 'login'
          this.setLoginStatus('login')
        } else if (res.Code === 10111) {
          Toast(this.$t('lang.login.toast10111'))
          this.setLoginStatus('login')
        } else if (res.Code === 10122) {
          Toast(this.$t('lang.login.toast10122'))
          this.setLoginStatus('login')
        } else if (res.Code === 10003) {
          this.showInactive = true
        } else {
          this.register()
        }
      }).catch((err) => {
        console.log(err)
        Toast(this.$t('lang.common.fail'))
      })
    },
    /****
     * 2024-09-13 YTW 限制绑定下级机制
     */
    register () {
      let cid = localStorage.getItem('cid')
      // if (this.couponCode) { // 2022-12-21 HHY 注释
      //   cid = this.couponCode.toLowerCase()
      // }

      const username = LogUtils.generateUUID().replace(/-/g, '')

      const url = '/innovation/account/register'
      let data = {
        mobile: this.tel,
        countryCode: this.countryCode,
        userName: username,
        currencyName: this.currency,
        campaignId: cid,
        snsCode: this.sns,
        shareCode: this.inviteCode,
        visitorCode: this.visitorCode,
        shareType: this.shareType ? this.shareType : '',
        internation: this.$store.state.internation
      }
      let VIRdataStr = localStorage.getItem('shareVIRData')
      let VIRdata = null
      if (VIRdataStr) {
        VIRdata = JSON.parse(VIRdataStr)
      }
      if (VIRdata) {
        data.campaignId = VIRdata.cid
        data.VirShare = 'VIR'
      }
      request('post', url, data).then(res => {
        if (res.CreateInviteCode === -19 || res.CreateInviteCode === -1) { // 请勿邀请自己的账号作为下线
          Toast(this.$t('lang.message.BindingFailed'))
          setTimeout(() => {
            this.regNext(res, cid)
          }, 1000)
        } else if (res.Code === 10111) {
          Toast(this.$t('lang.login.toast10111'))
        } else if (res.Code === 10122) {
          Toast(this.$t('lang.login.toast10122'))
        } else {
          if (VIRdata) {
            localStorage.setItem('VIRRegisterSuccess', true)
          }
          this.regNext(res, cid)
        }
      }).catch(() => {
        Toast(this.$t('lang.message.registerFail'))
      })
    },
    regNext (res, cid) {
      if (res.Code === 0) {
        this.inviteCode = ''
        localStorage.setItem('userInfo', JSON.stringify({
          UserName: this.userName,
          mobile: this.tel,
          ...res
        }))
        if (!localStorage.getItem('cid') && !res.CampaignId && cid) {
          localStorage.setItem('cid', cid)
        }
        if (res.CampaignId) {
          localStorage.setItem('cid', res.CampaignId)
        }
        afListener('Register')

        // // Start-A 2021-08-04 C007 重新登录时 重设7天Gift和24小时充值送弹框状态
        // store.commit('setHideGiftPop', false)
        // // End-A

        this.fetchNext()
      } else {
        LogUtils.saveUserEventParams('RegisterError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
        if (res.Code === 10000) {
          Toast(this.$t('lang.message.usernameExit'))
        } else if (res.Code === 10001) {
          Toast(this.$t('lang.message.mobileExit'))
        } else if (res.Code === 60001) {
          Toast(this.$t('lang.login.codeExpired'))
        } else if (res.Code === 60002) {
          Toast(this.$t('lang.login.codeExpired'))
        } else {
          Toast(this.$t('lang.message.registerFail'))
        }
      }
    },
    fetchBack () {
      if (this.fromRoute === 'Share' || this.fromRoute === 'Promotion' || this.fromRoute === 'Support' || this.fromRoute === 'Earn' || this.fromRoute === 'ShareFiesta') {
        this.$router.go(-1)
      } else {
        this.$router.push('/Home')
      }
    },
    fetchNext () {
      this.closePop()
      this.$router.go(0)
      // if (this.fromRoute === 'Promotion' || this.fromRoute === 'Support' || this.fromRoute === 'Earn' || this.fromRoute === 'ShareFiesta') {
      //   this.$router.go(-1)
      // } else {
      //   this.$router.push('/Home')
      // }
    }
  }
}
</script>

<style lang="less" scoped>
.loginPopMarsk {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.7);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  .loginPop{
    height: 144.722vw;
    width: 86.666vw;
    box-sizing: border-box;
    background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #0C0C0C 3.18%, #131313 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
    border: 1px solid #737373;
    border-radius: 4.166vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    .close{
      position: absolute;
      bottom: -8vw;
      height: 4.222vw;
      width: 3.888vw;
    }
    .popTitle{
      font-family: 'Arial';
      font-style: normal;
      font-weight: 700;
      font-size: 5.833vw;
      text-transform: capitalize;
      color: #FFFFFF;
      margin-top: 4.861vw;
    }
    .loginPage {
      width: 100%;
      height: 100%;
      overflow-x: hidden;

      .loginContainer {
        //position: absolute;
        //top: 68.5vw;
        //left: 50%;
        //width: 85.277vw;
        //transform: translate(-50%);
        padding: 4.444vw;
        .login {
          color: #E2C38F;
          height: max-content;

          .desc {
            font-size: 14px;
            font-weight: 700;
            line-height: 16px;
            margin-bottom: 10px;
            color: #8c939d;
          }

          .title {
            font-family: Inter;
            position: relative;
            width: 100%;
            font-size: 4.444vw;
            font-weight: 400;
            text-align: left;
            margin-bottom: 2vw;
          }

          .input {
            position: relative;
            top: 1vw;
            width: 100%;
            height: 8.8889vw;
            display: flex;
            justify-content: space-between;
            align-items: center;
            overflow: hidden;
            margin-bottom: 5.277vw;

            .selectInput {
              font-family: Inter;
              display: flex;
              justify-content: center;
              align-items: center;
              text-align: center;
              color: #FFFFFF;
              font-size: 4.444vw;
              font-weight: 400;
              line-height: 10vw;
              box-sizing: border-box;
              width: 18.95vw;
              height: 8.611vw;
              border: 1px solid #867860;
              border-radius: 1.388vw;
            }
            .telInput{
              width: 55.758vw;
              height: 8.611vw;
              box-sizing: border-box;
              border: 1px solid #867860;
              border-radius: 3px;
            }
            .snsInput{
              box-sizing: border-box;
              width: 43.277vw;
              height: 8.611vw;
              border: 1px solid #867860;
              border-radius: 3px;
            }
            input {
              font-family: Inter;
              background: none;
              outline: none;
              border: 0.278vw solid #F6D9AA;
              border-radius: 1.388vw;
              height: 8.8889vw;
              width: 48.611vw;
              text-align: center;
              color: #FFFFFF;
              font-size: 4.444vw;
              font-weight: 400;
              line-height: 10vw;
              padding: 0 2vw;
            }

            .err {
              position: absolute;
              bottom: -30px;
              color: red;
              font-size: 16px;
            }
          }
        }

        .resend {
          background: linear-gradient(0deg, #F1DAB0, #F1DAB0),
          linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
          width: 33.055vw;
          height: 10.555vw;
          border-radius: 2.222vw;
          font-size: 4.16vw;
          font-weight: 700;
          line-height: 10.555vw;
          text-align: center;
          color: #000000;
        }

        .wait {
          background: #797979;
          color: #000D2E;
          width: 33.055vw;
          height: 10.555vw;
          border-radius: 2.222vw;
          font-size: 4.16vw;
          font-weight: 700;
          line-height: 10.555vw;
          text-align: center;
        }

        .picBtn {
          width: 33.055vw;
          height: 8.8889vw;
          overflow: hidden;
          background: #BDB0B0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .GoogleLoginBox{
          width: 77.22vw;
          height: 11.722vw;
         /deep/ .loginElements{
           width: 77.22vw !important;
           height: 11.722vw !important;
          }
        }
        .btn {
          margin-top: 12vw;
          text-align: center;

          .submit {
            position: relative;
            background: linear-gradient(0deg, #F1DAB0, #F1DAB0),
            linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
            width: 76.586vw;
            height: 9.444vw;
            line-height: 9.444vw;
            border-radius: 1.388vw;
            font-size: 4.7vw;
            font-weight: 700;
            text-align: center;
            color: #000000;
            z-index: 1;
          }

          .disabled {
            position: relative;
            background: #797979;
            color: #000D2E;
            line-height: 9.444vw;
            border-radius: 1.388vw;
            font-size: 4.7vw;
            font-weight: 700;
            text-align: center;
            z-index: 1;
            width: 76.586vw;
            height: 9.444vw;
          }
        }
      }

      .inactive {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        background-color: #111111;
        z-index: 9999;

        .ban {
          position: relative;
          margin-top: calc(56px + 22.222vw);
          left: 52.222%;
          transform: translate(-50%);
          width: 31.239vw;
          height: 29.444vw;

          img {
            width: 100%;
            height: 100%
          }
        }

        .close {
          position: relative;
          top: 6vw;
          width: 92vw;
          height: 3.888vw;
          display: flex;
          justify-content: flex-end;
          align-items: center;

          img {
            width: 3.888vw;
            height: 3.888vw;
          }
        }

        .tips {
          position: relative;
          margin-top: 12vw;
          padding: 0 8vw;
          width: 100vw;
          font-size: 4.722vw;
          font-weight: 500;
          line-height: 5vw;
          text-align: left;
          color: #FFFFFF;
          letter-spacing: 0.01em;

          a {
            font-size: 4.722vw;
            font-weight: 500;
            line-height: 5.6vw;
            text-align: left;
            color: #0583F8;
            letter-spacing: 0.01em;
          }
        }

        .liveButton {
          position: relative;
          left: 50%;
          transform: translate(-50%);
          background: linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
          text-align: center;
          width: 83.661vw;
          height: 10.555vw;
          line-height: 10.555vw;
          border-radius: 1.388vw;
          font-size: 4.166vw;
          font-weight: 600;
          color: #000000;
          margin-top: 20vw;
        }
      }

      /deep/ .mint-popup-bottom {
        width: 100%;
      }

      /deep/ .picker {
        .picker-toolbar {
          background-color: #353535;

          span {
            float: right;
            color: #fff;
            font-weight: 500;
            font-size: 18px;
            line-height: 40px;
            padding-right: 10px;
          }
        }

        .picker-items {
          background-color: rgba(51, 51, 51, .9);

          .picker-item {
            color: #7b8075;
          }

          .picker-selected {
            color: #c0c0c0;
            background-color: #474747;
            width: 95%;
            margin: 0 auto;
            border-radius: 5px;
            border: none;
          }

          .picker-center-highlight {
            display: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginPop/index.vue